import React from 'react';
import { IconProps } from '../IconProps';
const SvgChild = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 26 26" fill="none" {...props}>
    <path
      d="M21.453 8.763A10.007 10.007 0 0012 2a1.67 1.67 0 00-1.667 1.667 1.669 1.669 0 002.847 1.177 1.002 1.002 0 011.416 1.413A3.643 3.643 0 0112 7.335a3.67 3.67 0 01-3.667-3.667c0-.35.066-.681.156-1.001C5.747 3.704 3.525 5.9 2.547 8.764A3.344 3.344 0 000 12.001a3.343 3.343 0 002.547 3.238A10.01 10.01 0 0012 22a10.01 10.01 0 009.453-6.762A3.344 3.344 0 0024 12a3.346 3.346 0 00-2.547-3.238zM8 13.333a1.334 1.334 0 110-2.667 1.334 1.334 0 010 2.667zm4 4.89a2.666 2.666 0 01-2.667-2.667c0-.49.398-.89.89-.89h3.556a.89.89 0 01.889.89 2.666 2.666 0 01-2.667 2.667H12zm4-4.89a1.334 1.334 0 110-2.667 1.334 1.334 0 010 2.667z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgChild;
